import validate from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45check_45auth_45global from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/middleware/01.checkAuth.global.ts";
import _02_45check_45hotel_45info_45global from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/middleware/02.checkHotelInfo.global.ts";
import _03_45check_45dataform_45passed_45global from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/middleware/03.checkDataformPassed.global.ts";
import _04_45redirect_45global from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/middleware/04.redirect.global.ts";
import manifest_45route_45rule from "/Volumes/Tian_SanDisk/DEV/datawang/frontend-demo20251020/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45check_45auth_45global,
  _02_45check_45hotel_45info_45global,
  _03_45check_45dataform_45passed_45global,
  _04_45redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}